import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=1b975b4e&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b975b4e')) {
      api.createRecord('1b975b4e', component.options)
    } else {
      api.reload('1b975b4e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=1b975b4e&", function () {
      api.rerender('1b975b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/accordion/Accordion.vue"
export default component.exports